import { ThemeColors } from '../../../../tokens/colors/types';
import { blue, green, neutral, orange, purple, red } from './palette';
import { deals } from './product';
import { critical, info, positive, warning } from './semantic';

const primary: ThemeColors['primary'] = {
  '10': '#F7FCF5',
  '20': '#F0FAEB',
  '30': '#F7FBEB',
  '50': '#A5CD38',
  '70': '#7CA82B',
  '90': '#123300',
};

const secondary: ThemeColors['secondary'] = {
  '20': '#6CAE00',
  '30': '#6CAE00',
  '50': '#6CAE00',
  '70': '#6CAE00',
  '90': '#6CAE00',
};

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  info,
  warning,
  critical,
  positive,
  deals,
};

export default baseColors;
